// Annonces vocales.
// Les éléments d'interface sont fournis par initVoice(), et la vitesse est passée en
// paramètre à announce() : le module ne lit aucune globale de l'application.

const TTS_ICON_ON = '<path d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"/><path d="M15.536 8.464a5 5 0 010 7.072"/><path d="M18.364 5.636a9 9 0 010 12.728"/>';
const TTS_ICON_OFF = '<path d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"/><path d="M17 9l4 6M21 9l-4 6"/>';

let ttsEnabled = true;
let ttsState = { key: null, spoken: Infinity };
let ttsSpoken = {};
let btnTts = null;
let ttsIcon = null;

try {
    if (localStorage.getItem('bustracker_tts') === 'off') ttsEnabled = false;
} catch (e) {}   // mode privé : on reste sur la valeur par défaut

function isTtsEnabled() { return ttsEnabled; }

function updateTtsBtn() {
    if (!ttsIcon || !btnTts) return;
    ttsIcon.innerHTML = ttsEnabled ? TTS_ICON_ON : TTS_ICON_OFF;
    btnTts.classList.toggle('text-slate-300', !ttsEnabled);
    btnTts.classList.toggle('text-slate-600', ttsEnabled);
}

function initVoice(els) {
    btnTts = els.btnTts;
    ttsIcon = els.ttsIcon;
    if (btnTts) {
        btnTts.addEventListener('click', () => {
            ttsEnabled = !ttsEnabled;
            updateTtsBtn();
            try { localStorage.setItem('bustracker_tts', ttsEnabled ? 'on' : 'off'); } catch (e) {}
            if (ttsEnabled) speak('Voix activée');
            else cancelSpeech();
        });
    }
    updateTtsBtn();
}

function speak(text) {
    if (!ttsEnabled || !text) return;
    if (typeof speechSynthesis === 'undefined') return;
    try {
        const u = new SpeechSynthesisUtterance(text);
        u.lang = 'fr-CA';
        u.rate = 1.05;
        const v = speechSynthesis.getVoices().find(x => /^fr[-_]/i.test(x.lang));
        if (v) u.voice = v;
        // Une annonce en retard vaut moins que celle qui arrive : on coupe la précédente.
        speechSynthesis.cancel();
        speechSynthesis.speak(u);
    } catch (e) { /* voix indisponible : le bandeau reste la source de vérité */ }
}

function cancelSpeech() {
    try { if (typeof speechSynthesis !== 'undefined') speechSynthesis.cancel(); } catch (e) {}
    ttsState = { key: null, spoken: Infinity };
}

// Remise à zéro des annonces déjà faites, au chargement d'un nouveau trajet.
function resetAnnouncements() {
    ttsSpoken = {};
    ttsState = { key: null, spoken: Infinity };
}

// Deux annonces par manœuvre, et deux seulement : une quand l'instruction change, une au
// palier fixe. Le seuil lié à la vitesse qui existait ici rétrécissait à mesure que le bus
// ralentissait vers le virage (14·v − 400) ; comme le cliquet mémorisait CE seuil, chaque
// rétrécissement le franchissait à nouveau et rejouait l'instruction à chaque fix GPS.
const MANEUVER_SAY_M = 100;

function announce(key, dist, textFar, textNear) {
    if (!ttsEnabled) return;
    if (key !== ttsState.key) {
        // L'instruction vient de changer : on prévient sans attendre un palier. Sous 100 m le
        // palier est consommé du même coup, sinon on entendrait deux annonces coup sur coup.
        speak(textFar);
        ttsState = { key: key, spoken: dist <= MANEUVER_SAY_M ? MANEUVER_SAY_M : Infinity };
        return;
    }
    if (dist <= MANEUVER_SAY_M && MANEUVER_SAY_M < ttsState.spoken) {
        ttsState.spoken = MANEUVER_SAY_M;
        speak(textNear);
    }
}

// Annonce unique par cible, au franchissement du seuil.
function announceOnce(key, dist, threshold, text) {
    if (!ttsEnabled || ttsSpoken[key] || dist > threshold) return;
    ttsSpoken[key] = true;
    speak(text);
}

export {
    initVoice, isTtsEnabled, updateTtsBtn, speak, cancelSpeech, resetAnnouncements,
    MANEUVER_SAY_M, announce, announceOnce, TTS_ICON_ON, TTS_ICON_OFF
};
